import React, { memo } from 'react';
import cn from 'classnames';

import Divider from '../Divider'

import styles from './Modal.module.scss';

const ModalFooter = props => {
  const { children, className } = props;

  const cnModalFooter = cn(styles.modalFooter, className);

  return (
    <div {...props} className={cnModalFooter}>
      <Divider size="small" />
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
};

export default memo(ModalFooter);
